import { baseThemeData } from "./baseTheme";

const baseMrgThemeData = {
  ...baseThemeData,
  colors: {
    ...baseThemeData.colors,
    primary: "#41B169",
    header: "000",
    brandColor: "rgba(235, 237, 239, 0.2)",
    textColor: "#EBEDEF",
    colorPrimary: "#05372C",
    colorSecondary: "#FFFFFF",
    colorFontBlack: "#015536",
    hooverLinkColors: "#CCCCCC",
    linkBorder: "rgba(235, 237, 239, 0.2)",
    textColorBtnOutlined: "#fff",
    textColorBtnContained: "#05372C",
    textColorBtnContainedMobile: "#05372C",
    ColorBtnContainedHoover: "#015536",
    textColorBtnOutlinedHover: "#015536",
    MyAccountAreaHeaderBackground: "#015536",
    iconColor: "#6B6B6C",
    BalanceBoxTitleColor: "#41B169"
  },
  typography: {
    fontFamily: "MontserratRegular, Arial, sans-serif",
    fontFamilyBold: "MontserratBold, Arial, sans-serif",
    fontFamilySemiBold: "MontserratSemiBold, Arial, sans-serif",
    fontFamilyDefaultBold: "MontserratBold",
    fontWeight: 700,
    fontSizeMobile: `1rem`,
    fontWeightMobile: 700
  },
  backgrounds: {
    mainBG: "#05372C",
    boxBG: "#015536",
    hoverColorContained: "#05372C",
    hoverColorOutlined: "#FFFFFF"
  },
  borders: {
    ...baseThemeData.borders,
    borderBottom: "rgba(235, 237, 239, 0.2)",
    borderBottomFooter: "rgba(235,237,239,0.2)"
  }
};

const computePanelThemeData = () => {
  return {
    panel: {
      header: {
        title: {
          icon: { defaultColor: baseMrgThemeData.colors.iconColor },
          defaultColor: "#313233"
        },
        description: {
          defaultColor: "#047c4c"
        }
      }
    }
  };
};

const computeExpandablePanelThemeData = () => {
  return {
    expandablePanel: {
      before: {
        borderTopColor: "#ffffff",
        boxShadow: "0px -1px 0px 0px",
        boxShadowColor: "#bcbcbc"
      },
      header: {
        icon: { defaultColor: baseMrgThemeData.colors.iconColor },
        title: {
          defaultColor: "#313233",
          expandedColor: "#313233"
        },
        arrow: { defaultColor: "#bcbcbc", expandedColor: "#047c4c" }
      }
    }
  };
};

const computeListThemeData = () => {
  return {
    list: {
      title: {
        defaultColor: "#313233",
        borderBottomColor: "#bcbcbc",
        boxShadow: "0px 1px 0px 0px",
        boxShadowColor: "#ffffff"
      },
      item: {
        borderBottomColor: "#bcbcbc",
        boxShadow: "0px 1px 0px 0px",
        boxShadowColor: "#ffffff",
        text: { defaultColor: "#313233" },
        checkbox: {
          checkedBackground: "#015536",
          unCheckedBackground: "#bcbcbc",
          defaultColor: "#ffffff"
        }
      }
    }
  };
};

const computeCheckboxListThemeData = () => {
  return {
    checkboxList: {
      title: {
        defaultColor: "#313233",
        borderBottomColor: "#bcbcbc",
        boxShadow: "0px 1px 0px 0px",
        boxShadowColor: "#ffffff"
      }
    }
  };
};

const computeDrawerThemeData = () => {
  return {
    drawer: {
      header: {
        backgroundColor: baseMrgThemeData.backgrounds.boxBG
      },
      area: { background: "#f5f5f5" },
      box: { background: "#ebedef" }
    }
  };
};

const computeLinkButtonThemeData = () => {
  return {
    linkButtonTitle: {
      defaultColor: "#313233",
      borderBottomColor: "#bcbcbc",
      boxShadow: "0px 1px 0px 0px",
      boxShadowColor: "#ffffff"
    },
    linkButton: {
      icon: { defaultColor: "#6B6B6C" },
      title: { defaultColor: "#313233" },
      description: {
        defaultColor: "#047c4c"
      },
      arrow: {
        defaultColor: "#bcbcbc"
      }
    }
  };
};

const computeLinkItemThemeData = () => {
  return {
    linkItem: {
      icon: { defaultColor: "rgba(235, 237, 239, 0.5)" }
    }
  };
};

const getHeaderButtonPcStyles = () => {
  return {
    ...baseMrgThemeData,
    typography: {
      ...baseMrgThemeData.typography,
      fontSize: `1.4rem`
    },
    backgrounds: {
      ...baseMrgThemeData.backgrounds,
      hoverColorOutlined: "#FFFFFF"
    },
    colors: {
      ...baseMrgThemeData.colors,
      headerButtonPrimary: "#FCE403",
      headerButtonPrimaryMobile: "#FCE403",
      headerButtonBrandColor: `linear-gradient(90deg, #F1C141 0%, #F9F19A 48.96%, #F1C141 100%)`,
      brandColor: `linear-gradient(90deg, #F1C141 0%, #F9F19A 48.96%, #F1C141 100%)`,
      outlinedBorderColor: "#FFFFFF"
    }
  };
};

const computePopupThemeData = () => {
  return {
    popupButton: {
      fontFamily: "MontserratBold",
      dotsFloatingBackgroundColor: "#0A0A0A",
      outlined: {
        backgroundColor: "#ebedef",
        color: "#015536",
        borderColor: "#015536",
        hover: {
          backgroundColor: "#015536",
          color: "#fff",
          borderColor: "#015536"
        }
      },
      contained: {
        background: "#015536",
        color: "#ffffff",
        borderColor: "#015536",
        hover: {
          backgroundColor: "#ebedef",
          color: "#015536",
          borderColor: "#015536"
        }
      },
      underlined: {
        color: "#015536",
        hover: {
          textDecoration: "none",
          border: "unset"
        }
      }
    },
    popupContainer: {
      textColor: "#000000",
      subtitleColor: "#015536",
      message: {
        color: "#015536"
      },
      zIndex: 200,
      backgroundColor: "#ffffff",
      titleBackgroundColor: "#015536",
      iconColor: "#015536",
      pokerDownloadGuide: {
        titleWrapperColor: "#047c4c",
        underlineTextWrapperColor: "#047c4c",
        svgWrapperColor: "#ffffff"
      }
    },
    popupFooter: {
      fontFamily: "MontserratMedium",
      color: "#a5a5a5"
    }
  };
};

const computeControlCenterThemeData = () => {
  return {
    controlCenter: {
      headerButton: {
        backgroundColor: "#fff",
        borderColor: "transparent",
        svgBackgroundColor: "#fff"
      }
    }
  };
};

const computeLanguagesDrawerThemeData = () => {
  return {
    languagesDrawer: {
      fontFamily: "MontserratSemiBold",
      checkedOptionBackgroundColor: "047c4c",
      backgroundColor: "#171717",
      textColor: "#FFFFFF"
    }
  };
};

export const MrgThemeData = {
  ...baseMrgThemeData,
  getHeaderButtonPcStyles,
  ...computeLinkButtonThemeData(),
  ...computePanelThemeData(),
  ...computeExpandablePanelThemeData(),
  ...computeDrawerThemeData(),
  ...computeListThemeData(),
  ...computeCheckboxListThemeData(),
  ...computeLinkItemThemeData(),
  ...computePopupThemeData(),
  ...computeControlCenterThemeData(),
  ...computeLanguagesDrawerThemeData()
};
